const Soils = () =>
  import(
    /* webpackChunkName: "Soils" */ "@/components/ssp/missions/mission/mission-interpretation/Soils.vue"
  );

const UndergroundWater = () =>
  import(
    /* webpackChunkName: "UndergroundWater" */ "@/components/ssp/missions/mission/mission-interpretation/UndergroundWater.vue"
  );

const SurfaceWaterSediments = () =>
  import(
    /* webpackChunkName: "SurfaceWaterSediments" */ "@/components/ssp/missions/mission/mission-interpretation/SurfaceWaterSediments.vue"
  );

const SoilGas = () =>
  import(
    /* webpackChunkName: "SoilGas" */ "@/components/ssp/missions/mission/mission-interpretation/SoilGas.vue"
  );

const AmbientAir = () =>
  import(
    /* webpackChunkName: "AmbientAir" */ "@/components/ssp/missions/mission/mission-interpretation/AmbientAir.vue"
  );

const FoodProducts = () =>
  import(
    /* webpackChunkName: "FoodProducts" */ "@/components/ssp/missions/mission/mission-interpretation/FoodProducts.vue"
  );

const ExcavatedSoil = () =>
  import(
    /* webpackChunkName: "ExcavatedSoil" */ "@/components/ssp/missions/mission/mission-interpretation/ExcavatedSoil.vue"
  );

const InvestigationSynthesis = () =>
  import(
    /* webpackChunkName: "InvestigationSynthesis" */ "@/components/ssp/missions/mission/mission-interpretation/InvestigationSynthesis.vue"
  );

import {
  checkActiveMissionsCodesIncludes,
  INTERPRETATION_MISSION_CODES,
} from "@/composables/missions/useMissionsConfigCodes";

export default [
  // Sols (si A200 cochée)
  {
    path: "soils",
    name: "Soils",
    component: Soils,
    beforeEnter: (to, from, next) => {
      if (checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.SOILS])) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Eaux souterraines (si A210 cochée)
  {
    path: "underground-water",
    name: "Groundwater",
    component: UndergroundWater,
    beforeEnter: (to, from, next) => {
      if (checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.GROUNDWATER])) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Eaux superficielles/Sédiments (si A220 cochée)
  {
    path: "surface-water-sediments",
    name: "SurfaceWaterSediments",
    component: SurfaceWaterSediments,
    beforeEnter: (to, from, next) => {
      if (
        checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.SURFACE_WATER_SEDIMENTS])
      ) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Gaz des sols (si A230 cochée)
  {
    path: "soil-gas",
    name: "SoilGas",
    component: SoilGas,
    beforeEnter: (to, from, next) => {
      if (checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.SOIL_GAS])) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Air ambiant (si A240 cochée)
  {
    path: "ambient-air",
    name: "AmbientAir",
    component: AmbientAir,
    beforeEnter: (to, from, next) => {
      if (checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.AMBIENT_AIR])) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Denrées alimentaires (si A250 cochée)
  {
    path: "food-products",
    name: "FoodProducts",
    component: FoodProducts,
    beforeEnter: (to, from, next) => {
      if (checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.FOOD_PRODUCTS])) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Terres excavées (si A260 cochée)
  {
    path: "excavated-soil",
    name: "ExcavatedSoil",
    component: ExcavatedSoil,
    beforeEnter: (to, from, next) => {
      if (checkActiveMissionsCodesIncludes([INTERPRETATION_MISSION_CODES.EXCAVATED_SOIL])) {
        next();
      } else {
        next({ name: "InvestigationSynthesis" });
      }
    },
    meta: {
      showSubNavBar: true,
    },
  },
  // Synthèse des investigations (tout le temps)
  {
    path: "",
    name: "InvestigationSynthesis",
    component: InvestigationSynthesis,
    meta: {
      showSubNavBar: true,
    },
  },
];
